module.exports = __webpack_public_path__ + "fcc8d27c1b6adeaa6423651f4be51fbf.svg";